import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-qui-sommes-nous',
  templateUrl: './qui-sommes-nous.component.html',
  styleUrls: ['./qui-sommes-nous.component.scss']
})
export class QuiSommesNousComponent implements OnInit {

  constructor(
    public meta: Meta, 
    public title: Title
  ) { }

  ngOnInit() {
    this.meta.updateTag({ name: 'description', content: "Avec Rupture by Cobham, nous déployons un premier service de diagnostic et de simulation de toutes les paies pour toutes les conventions collectives." }); 
    this.meta.updateTag({ name: 'keywords', content: "bulletin salaire paie diagnostic simulation convention collective"})
  }

}
